export default "__VITE_ASSET__BLVWb$4T__"